var getReloj = function getReloj(state) {
  return state.reloj;
};

export var getVisible = function getVisible(state) {
  return getReloj(state).visible;
};
export var getConfig = function getConfig(state) {
  return getReloj(state).config;
};
export var getPosicion = function getPosicion(state) {
  var _getConfig = getConfig(state),
      x = _getConfig.x,
      y = _getConfig.y;

  return {
    x: x,
    y: y
  };
};